import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { EntityInspectorDeactivateSource } from './entity.inspector.contracts';

/**
 * `true` means clean, saved, or explicitly discarded. `false` means stay — Angular cancels the
 * navigation and restores the URL, so the same editor and URL remain.
 *
 * The `$deactivatePending` branch closes a real race: the user presses Escape, `canDeactivateAll` is
 * awaiting a confirm dialog, then they click a side-nav link. Without it the guard would ask the
 * same inspector a second time while the first prompt is still open.
 */
export const entityInspectorRouteGuard: CanDeactivateFn<unknown> = () => {

  const source = inject(EntityInspectorDeactivateSource);

  if (source.$deactivating()) return true;
  if (source.$deactivatePending()) return false;

  // Same question, different stakes, so the reason distinguishes them: 'change-inspector' means the
  // excursion continues and only this editor is being replaced, where 'navigate' means the inspector is
  // going away entirely. A guard may word its prompt differently; none is obliged to care.
  const reason = source.isOpeningInspector() ? 'change-inspector' : 'navigate';

  return source.canDeactivateActive(reason);
};
